import React, { useEffect, useRef, useState } from "react";
import styles from "./shop_sidebar.module.css";
import {
  faQuestionCircle,
  faX,
  faHome,
  faUser,
  faShoppingBag,
  faSignOutAlt,
  faEnvelope
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import useAuthenticate from "../../../hooks/useAuthenticate";
import { logout as setLogout } from "../../../stores/features/userSlice";
import useGetUser from "../../../hooks/useGetUser";
import usePendingCart from "../../../hooks/usePendingCart";
import LoginPopup from "../login_popup/login_popup";
import PendingOrderNotification from "../pending_order/PendingOrderNotification";
import SpinningArrow from "../loaders/SpinningArrow";

export default function ShopSidebar({ show, setter, showLogin }) {
  let authenticated = useAuthenticate();
  const [showModal, setShowModal] = useState(false);
  const componentRef = useRef(null);
  const dispatch = useDispatch();
  const user = useGetUser();
  const navigate = useNavigate();
  const { data: pendingOrders } = usePendingCart();

  // Utiliser une référence pour suivre l'état précédent de show
  const isInitialMount = useRef(true);

  // Vérifier s'il y a des commandes en attente
  const hasPendingOrders = pendingOrders && pendingOrders.length > 0;

  useEffect(() => {
    // Éviter d'ajouter l'écouteur d'événement lors du premier rendu
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    const handleClickOutside = (event) => {
      // Vérifier si le clic est en dehors de la sidebar et si la sidebar est ouverte
      if (
        componentRef.current &&
        !componentRef.current.contains(event.target) &&
        show
      ) {
        // Utiliser setTimeout pour éviter les problèmes de cycle de rendu
        setTimeout(() => {
          setter(false);
        }, 0);
      }
    };

    // Ajouter l'écouteur d'événement seulement si la sidebar est ouverte
    if (show) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [show, setter]);

  const logout = () => {
    dispatch(setLogout());
    navigate("/locate", { replace: true });
  };

  const loginOrProfile = () => {
    if (authenticated) {
      navigate("/profile/");
    } else {
      setShowModal(true);
    }
  };

  useEffect(() => {
    if (showLogin > 0) {
      setShowModal(true);
    }
  }, [showLogin]);

  // Empêcher la propagation des clics à l'intérieur de la sidebar
  const handleSidebarClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div
      className={`${styles.sidebar} ${show ? styles.active : ""}`}
      ref={componentRef}
      onClick={handleSidebarClick}
    >
      <LoginPopup show={showModal} setShow={setShowModal} />

      <div className={styles.sidebarHeader}>
        <div
          className={styles.closeBtn}
          onClick={(e) => {
            e.stopPropagation();
            setter(false);
          }}
        >
          <FontAwesomeIcon icon={faX} />
        </div>
      </div>

      <div className={styles.userProfile} onClick={loginOrProfile}>
        <div className={styles.avatar}>
          {authenticated ? (
            user?.data?.user_data?.name?.charAt(0) || "U"
          ) : (
            <FontAwesomeIcon icon={faUser} />
          )}
        </div>
        <div className={styles.userInfo}>
          <h3>{authenticated ? `Bonjour ${user?.data?.user_data?.name}` : "Se connecter"}</h3>
          {authenticated && (
            <p className={styles.points}>{user?.data?.user_data?.points || 0} Points Utilisables</p>
          )}
        </div>
      </div>

      {/* Notification de commande en attente */}
      {authenticated && <PendingOrderNotification />}

      {/* {hasPendingOrders && (
        <div className={styles.pendingOrderSection}>
          <SpinningArrow
            badgeCount={pendingOrders.length}
            onClick={() => setShowModal(true)}
            size="normal"
          />
          <span className={styles.pendingOrderText}>Commande en cours</span>
        </div>
      )} */}

      <div className={styles.menuItems}>
        <div className={styles.menuItem} onClick={() => navigate("/")}>
          <FontAwesomeIcon icon={faHome} className={styles.icon} />
          <span>Accueil</span>
        </div>

        <div className={styles.menuItem} onClick={() => navigate("/contact")}>
          <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
          <span>Contact</span>
        </div>

        <div
          className={styles.menuItem}
          onClick={() => {
            if (!authenticated) {
              setShowModal(true);
              return;
            }
            navigate("/profile");
          }}
        >
          <FontAwesomeIcon icon={faUser} className={styles.icon} />
          <span>Profil</span>
        </div>

        <div
          className={styles.menuItem}
          onClick={() => {
            if (!authenticated) {
              setShowModal(true);
              return;
            }
            navigate("/my_orders");
          }}
        >
          <FontAwesomeIcon icon={faShoppingBag} className={styles.icon} />
          <span>Mes commandes</span>
          {authenticated && hasPendingOrders && (
            <div className={styles.notificationBadge}>{pendingOrders.length}</div>
          )}
        </div>

        {authenticated && (
          <div className={styles.menuItem} onClick={logout}>
            <FontAwesomeIcon icon={faSignOutAlt} className={styles.icon} />
            <span>Déconnexion</span>
          </div>
        )}
      </div>

      <div className={styles.sidebarFooter}>
        <div className={styles.support}>
          <FontAwesomeIcon icon={faQuestionCircle} className={styles.icon} />
          <span>Assistance: 78 116 92 92</span>
        </div>
      </div>
    </div>
  );
}
